import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import rootReducer from '../reducers';

let middlewares = [thunkMiddleware];

if (process && process.env && process.env.NODE_ENV !== 'production') {
  const skipActionTypesList = [
    '@@redux-form/REGISTER_FIELD',
    '@@redux-form/UNREGISTER_FIELD',
    '@@redux-form/TOUCH',
    '@@redux-form/FOCUS',
    '@@redux-form/BLUR',
  ];
  const createLogger = require('redux-logger').createLogger;
  const logger = createLogger({
    collapsed: true,
    predicate: (getState, action) =>
      skipActionTypesList.indexOf(action.type) === -1,
  });

  middlewares.push(logger);
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      trace: true,
      traceLimit: 25,
    })
  : compose;

function configureStore(initialState) {
  const store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(...middlewares))
  );

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      const nextRootReducer = require('../reducers');
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
}

let reduxStore;
export default function getStore(initialState) {
  if (!reduxStore) {
    reduxStore = configureStore(initialState);
  }

  return reduxStore;
}
